import React from "react";
import { Outlet } from "react-router-dom";

const Page = () => {
  return (
      <div className="p-5">
        <Outlet />
      </div>
  );
};

export default Page;
